<template>
  <v-card class="pa-3">
    <v-row class="ml-1 mr-1">
      <v-col v-if="mode === 'prestamo' || mode === 'prestamos'">
        <h3> Correspondientes a contrato profesional con vigencia desde {{ inValidoDesde }} hasta {{ inValidoHasta }}</h3>
      </v-col>
      <base-material-tabs v-model="active_tab" color="warning">
        <template v-slot:items>
          <v-row>
            <v-spacer />
            <v-btn v-if="$can('M_contratos_crear')" class="mr-3" elevation="1" color="success" fab small :disabled="deshabilitarAgregar" @click="showAddDerechoObligacion(active_tab)">
              <v-icon>
                mdi-plus
              </v-icon>
            </v-btn>
            <v-tooltip v-if="condonar && active_tab === 0 && $can('M_condonaciones')" top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn class="mr-3" v-bind="attrs" elevation="1" color="success" fab small :disabled="cuotasACondonar.length === 0" v-on="on" @click="confirmCondonacion()">
                  <v-icon>
                    mdi-file-cancel-outline
                  </v-icon>
                </v-btn>
              </template>
              <span>Condonar cuotas seleccionadas (Derecho)</span>
            </v-tooltip>
            <v-tooltip v-if="condonar && active_tab === 1 && $can('M_condonaciones')" top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" class="mr-3" elevation="1" color="success" fab small :disabled="obligacionesACondonar.length === 0" v-on="on" @click="confirmCondonacionObligacion()">
                  <v-icon>
                    mdi-file-cancel-outline
                  </v-icon>
                </v-btn>
              </template>
              <span>Condonar cuotas seleccionadas (Obligacion)</span>
            </v-tooltip>
          </v-row>
        </template>
        <v-tab>
          Derechos
        </v-tab>
        <v-tab>
          Obligaciones
        </v-tab>
        <v-tab-item>
          <v-card flat class="my-0">
            <v-card-text class="px-0">
              <v-expansion-panels v-if="newDerechos.length">
                <v-expansion-panel v-for="(value, key) in newDerechos" :key="key">
                  <v-expansion-panel-header>
                    <div>
                      <v-icon v-if="mode !== 'show' && mode !== 'prestamos' && $can('M_contratos_crear')" dense left @click.stop="deleteItemDerecho(value)">
                        mdi-delete
                      </v-icon>
                      Derecho número: {{ key }} {{ derechoClubJugador(value) }}
                    </div>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-row>
                      <v-col v-for="(itemValue, key2) in value.detalle_derecho_representante" :key="key2" cols="4" class="pa-1">
                        <cuota :value="itemValue.monto" :cuota-id="itemValue.id" :saldo="itemValue.saldo" :numero="itemValue.cuota" :mode="mode" :simbolo="simboloMoneda(value.moneda_id)" :fecha-vencimiento="itemValue.vencimiento" :condonar="condonar"
                               @input="itemValue.monto = itemValue.saldo = $event" @inputDate="ajustarVencimientosCuotas(value.detalle_derecho_representante, itemValue, $event)" @selected="agregarCuota " :cuota="itemValue"
                        />
                      </v-col>
                    </v-row>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
              <div v-else class="ml-4">
                Aún no existen derechos para este contrato
              </div>
            </v-card-text>
          </v-card>
        </v-tab-item>
        <v-tab-item>
          <v-card flat class="my-0">
            <v-card-text class="px-0">
              <v-expansion-panels v-if="newObligaciones.length">
                <v-expansion-panel v-for="(value, key) in newObligaciones" :key="key">
                  <v-expansion-panel-header>
                    <div>
                      <v-icon v-if="mode !== 'show' && mode !== 'prestamos' && $can('M_contratos_crear')" dense left @click.stop="deleteItemObligacion(value)">
                        mdi-delete
                      </v-icon>
                      {{ value.obligacion.descripcion }}
                    </div>
                    <template v-if="(mode === 'new' || mode === 'edit') && value.obligacion.valor_monetario_sn && $can('M_contratos_crear')" v-slot:actions>
                      <v-tooltip content-class="top" top>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn color="success" small v-bind="attrs" v-on="on" @click.stop="obligacionAgregarCuotas(value)">
                            +
                          </v-btn>
                        </template>
                        <span>Agregar período</span>
                      </v-tooltip>
                      <v-icon class="ml-2">
                        mdi mdi-chevron-down
                      </v-icon>
                    </template>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-row>
                      <v-col v-for="(itemValue, key2) in value.detalle_obligacion_representante" :key="key2" cols="4" class="pa-1">
                        <obligacion :value="itemValue.cantidad" :numero="key2 + 1" :pagos-id="(itemValue.pagos_id)" :valor-monetario="(itemValue.valor_monetario)" :obligacion="itemValue" :fecha-vencimiento="itemValue.vencimiento" :detalle-id="itemValue.id" :mode="mode"
                                    :es-valor-monetario="value.obligacion.valor_monetario_sn === 1" :condonada="(itemValue.condonada_sn === 1 || itemValue.pagos_id !== null)"
                                    @input="itemValue.cantidad = $event" @inputDate="ajustarVencimientosObligaciones(value.detalle_obligacion_representante, value.obligacion.valor_monetario_sn, itemValue, $event)" @selected="agregarDetalleObligacion"
                        />
                      </v-col>
                    </v-row>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
              <div v-else class="ml-4">
                Aún no existen obligaciones para este contrato
              </div>
            </v-card-text>
          </v-card>
        </v-tab-item>
      </base-material-tabs>
      <!-- <derechos-y-obligaciones />      -->
    </v-row>
    <v-col cols="auto">
      <v-dialog v-model="dialogNuevasCuotas" max-width="500px">
        <v-card>
          <v-card-title class="headline">
            {{ derechoObligacionTittle }}
          </v-card-title>
          <v-card-text>
            <v-row>
              <v-col cols="6">
                <v-text-field v-model="importe" color="gold" label="Importe total" />
              </v-col>
              <v-col cols="6">
                <v-select v-model="monedaSelected" :items="monedas" label="Moneda" item-value="id" item-text="descripcion" />
              </v-col>
              <v-spacer />
              <v-col cols="auto">
                <v-item-group v-model="numeroDeCuotas">
                  <v-subheader class="pa-0" style="height: 22px">
                    <span>Cuotas</span>
                  </v-subheader>
                  <v-item v-for="n in presetCuotas" :key="n" v-slot="{ active, toggle }" :value="n">
                    <v-chip active-class="purple--text" :input-value="active" @click="toggle">
                      {{ n }}
                    </v-chip>
                  </v-item>
                </v-item-group>
              </v-col>
              <v-spacer />
              <v-col cols="auto" class="mr-4">
                <v-row align="center">
                  <v-text-field v-model="numeroDeCuotas" type="number" step="1" min="1" :max="maxCuotasCant" color="gold" label="Personalizar" style="width: 80px" />
                </v-row>
              </v-col>
            </v-row>
            <v-row v-if="clubSn && !active_tab" align="center">
              <span class="mr-2"> Acreedor: </span>
              <v-radio-group v-model="jugodarOclub" row mandatory>
                <v-radio label="jugador" value="jugador" />
                <v-radio label="club" value="club" />
              </v-radio-group>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn color="blue darken-1" text @click="agregarDerecho">
              Aceptar
            </v-btn>
            <v-spacer />
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-col>
    <confirm ref="confirmDO" />
    <generar-obligacion :fecha-desde="inValidoDesde" :fecha-hasta="inValidoHasta" :show="genObligacionDialog" :obligacion-existente="obligacionEdit" @nuevaObligacion="agregarObligacion" @close="genObligacionDialog = false" />
  </v-card>
</template>

<script>
  import Cuota from '../components/Cuota'
  import dayjs from 'dayjs'
  import Obligacion from '../components/Obligacion'
  import confirm from '../components/confirm'
  import generarObligacion from './GenerarObligacion'
  import Vue from 'vue'

  export default {
    name: 'DerechosObligaciones',
    components: {
      Cuota,
      Obligacion,
      confirm,
      generarObligacion,
    },
    props: {
      derechoRepresentante: {
        type: Array,
        default: function () {
          return []
        },
        required: false,
      },
      obligacionRepresentante: {
        type: Array,
        default: function () {
          return []
        },
        required: false,
      },
      inValidoDesde: {
        type: String,
        required: false,
        default: null,
      },
      inValidoHasta: {
        type: String,
        required: false,
        default: null,
      },
      mode: {
        type: String,
        required: false,
        default: null,
      },
      clubSn: {
        type: Boolean,
        required: false,
        default: false,
      },
      jugadorClubId: {
        type: Object,
        required: false,
        default: null,
      },
      condonar: {
        type: Boolean,
        default: false,
      },
    },
    data () {
      return {
        active_tab: 0,
        jugodarOclub: '',
        dialogNuevasCuotas: false,
        genObligacionDialog: false,
        cantidad: 0,
        monedaSelected: 1,
        obligacionSelected: {},
        numeroDeCuotas: 1,
        monedas: null,
        derechoObligacionTittle: '',
        presetCuotas: [1, 3, 6, 12, 18, 24],
        cuotas: [],
        maxCuotasCant: '1',
        importe: 0,
        newDerechos: this.derechoRepresentante,
        newObligaciones: this.obligacionRepresentante,
        cuotasACondonar: [],
        obligacionesACondonar: [],
        obligacionEdit: null,
        obligacionEditIndex: 0,
      }
    },
    computed: {
      deshabilitarAgregar: function () {
        return (this.inValidoDesde === '' || this.inValidoHasta === '' || this.mode === 'show' || (this.clubSn === true && this.jugadorClubId.clubId === null))
      },
    },
    watch: {
      newDerechos (val) {
        this.$emit('changeDerechos', val)
      },
      newObligaciones (val) {
        this.$emit('changeObligaciones', val)
      },
    },
    created () {
      this.getMonedas()
    },
    methods: {
      ajustarVencimientosCuotas (cuotas, cuota, nuevaFecha) {
        cuota.vencimiento = nuevaFecha
        if (cuota.cuota === 1) {
          for (var a = 1; a < cuotas.length; a++) {
            var fecha = dayjs(cuotas[a - 1].vencimiento)
            cuotas[a].vencimiento = fecha.add(1, 'month').format('YYYY-MM-DD')
            Vue.set(cuotas, a, cuotas[a])
          }
        }
      },
      ajustarVencimientosObligaciones (obligaciones, monetarioSN, obligacion, nuevaFecha) {
        obligacion.vencimiento = nuevaFecha
        if (obligaciones[0] === obligacion) {
          for (var a = 1; a < obligaciones.length; a++) {
            var fecha = dayjs(obligaciones[a - 1].vencimiento)
            obligaciones[a].vencimiento = fecha.add(1, 'month').format('YYYY-MM-DD')
            Vue.set(obligaciones, a, obligaciones[a])
          }
        }
      },
      condonarCuotas () {
        const aux = this.cuotasACondonar
        this.$http({
          method: 'put',
          url: '/api/derechos_condonar',
          data: {
            cuotas: aux,
          },
        }).then(response => {
          this.$store.commit('toast/show', { tipo: 'success', messages: ['Condonacion exitosa'] })
          this.cuotasACondonar = []
          this.$emit('cuotasCondonadas')
        }).catch(error => {
          if (error.response.data.errors) {
            this.$store.commit('toast/show', { tipo: 'error', messages: error.response.data.errors })
          } else {
            this.$store.commit('toast/show', { tipo: 'error', messages: ['Ocurrio un error en el servidor'] })
          }
        })
      },
      condonarDetalleObligacion () {
        const aux = this.obligacionesACondonar
        this.$http({ method: 'put', url: '/api/obligacion_condonar', data: { cuotas: aux } })
          .then(response => {
            this.$store.commit('toast/show', { tipo: 'success', messages: ['Condonacion exitosa'] })
            this.obligacionesACondonar = []
            this.$emit('cuotasCondonadas')
          })
          .catch(error => {
            if (error.response.data.errors) {
              this.$store.commit('toast/show', { tipo: 'error', messages: error.response.data.errors })
            } else {
              this.$store.commit('toast/show', { tipo: 'error', messages: ['Ocurrio un error en el servidor'] })
            }
          })
      },
      updateDO () {
        this.newDerechos = this.derechoRepresentante
        this.newObligaciones = this.obligacionRepresentante
      },
      agregarDetalleObligacion (datos) {
        if (datos.agregar) {
          this.obligacionesACondonar.push(datos.id)
        } else {
          this.obligacionesACondonar.splice(this.cuotasACondonar.indexOf(datos.id), 1)
        }
      },
      agregarCuota (datos) {
        if (datos.agregar) {
          this.cuotasACondonar.push(datos.id)
        } else {
          this.cuotasACondonar.splice(this.cuotasACondonar.indexOf(datos.id), 1)
        }
      },
      showAddDerechoObligacion (index) {
        if (index === 0) {
          this.derechoObligacionTittle = 'Generar derechos'
          this.generarPresetCuotas(1)
          this.dialogNuevasCuotas = true
        } else {
          this.obligacionEdit = null
          this.obligacionEditIndex = this.newObligaciones.length
          this.genObligacionDialog = true
        }
      },
      simboloMoneda (monedaId) {
        return (this.monedas) ? this.monedas.find(element => element.id === monedaId).simbolo : '$'
      },
      getMonedas () {
        this.$store.dispatch('axiosMod/getData', { url: '/api/moneda' }).then(response => { this.monedas = response })
      },
      deleteItemDerecho (value) {
        this.$refs.confirmDO.open('Alerta', 'Está seguro que desea eliminar el derecho? No se podra revertir', { color: 'red' }).then((confirm) => {
          if (confirm) {
            if (value.id !== undefined) {
              this.eliminarDerecho(value)
            } else {
              this.$emit('borrarDerecho', value)
            }
          }
        })
      },
      deleteItemObligacion (value) {
        this.$refs.confirmDO.open('Alerta', 'Está seguro que desea eliminar la obligación? No se podra revertir', { color: 'red' }).then((confirm) => {
          if (confirm) {
            if (value.id !== undefined) {
              this.eliminarObligacion(value)
            } else {
              this.$emit('borrarObligacion', value)
            }
          }
        })
      },
      confirmCondonacion () {
        this.$refs.confirmDO.open('Alerta', 'Está seguro que desea condonar la cuota? No se podra revertir', { color: 'red' }).then((confirm) => {
          if (confirm) {
            this.condonarCuotas()
          }
        })
      },
      confirmCondonacionObligacion () {
        this.$refs.confirmDO.open('Alerta', 'Está seguro que desea condonar la cuota? No se podra revertir', { color: 'red' }).then((confirm) => {
          if (confirm) {
            this.condonarDetalleObligacion()
          }
        })
      },
      eliminarDerecho: async function (idDerecho) {
        await this.$http.delete('/api/derecho_delete/' + idDerecho.id,
        ).then(response => {
          this.$store.commit('toast/show', { tipo: 'success', messages: ['Derecho eliminado'] })
          this.$emit('borrarDerecho', idDerecho)
        }).catch(error => {
          this.$store.commit('toast/show', { tipo: 'error', messages: [error.response.data.message] })
        })
      },
      eliminarObligacion: async function (idObligacion) {
        await this.$http.delete('/api/obligacion_delete/' + idObligacion.id,
        ).then(response => {
          this.$store.commit('toast/show', { tipo: 'success', messages: ['Obligacion eliminada'] })
          this.$emit('borrarObligacion', idObligacion)
        }).catch(error => {
          this.$store.commit('toast/show', { tipo: 'error', messages: [error.response.data.message] })
        })
      },
      derechoClubJugador: function (derechoRepresentante) {
        let derechoSobre = ''
        if (derechoRepresentante.club_id !== null) {
          derechoSobre = 'sobre el club'
        } else if (derechoRepresentante.jugador_id !== null) {
          derechoSobre = 'sobre el jugador'
        }
        return derechoSobre
      },
      generarPresetCuotas (esDerecho) {
        const desde = dayjs(this.inValidoDesde)
        const hasta = dayjs(this.inValidoHasta)
        const cantMesesPosibles = hasta.diff(desde, 'month')
        this.maxCuotasCant = cantMesesPosibles.toString()
        const cuotas = [1, 3, 6, 12, 18, 24]
        if (cuotas.indexOf(cantMesesPosibles) === -1) {
          cuotas.push(cantMesesPosibles)
        }
        this.presetCuotas = []
        for (let i = 0; i <= cuotas.length; i++) {
          if (cuotas[i] <= cantMesesPosibles) {
            this.presetCuotas.push(cuotas[i])
          }
        }
      },
      agregarDerecho () {
        if (!this.newDerechos) {
          this.newDerechos = []
        }
        if (this.jugodarOclub === '') { this.jugodarOclub = 'jugador' }
        const nDerecho = {
          club_id: (this.jugodarOclub === 'club') ? this.jugadorClubId.clubId : null,
          jugador_id: (this.jugodarOclub === 'jugador') ? this.jugadorClubId.jugadorId : null,
          moneda_id: this.monedaSelected,
          detalle_derecho_representante: this.generarCuotas(),
        }
        this.newDerechos.push(nDerecho)
        this.dialogNuevasCuotas = false
      },
      generarCuotas () {
        const cuotas = []
        const valorCuota = (this.importe) ? Math.round((this.importe / this.numeroDeCuotas) * 1e2) / 1e2 : 0
        const firstMonth = dayjs(this.inValidoDesde)
        let nextMonth = firstMonth.add(1, 'month')
        for (let index = 1; index <= this.numeroDeCuotas; index++) {
          const cuota = {
            cuota: index,
            monto: valorCuota,
            saldo: valorCuota,
            vencimiento: dayjs(nextMonth).format('YYYY-MM-DD'),
          }
          nextMonth = nextMonth.add(1, 'month')
          cuotas.push(cuota)
        }
        return cuotas
      },
      obligacionAgregarCuotas (value) {
        this.obligacionEditIndex = this.newObligaciones.indexOf(value)
        this.obligacionEdit = value
        this.genObligacionDialog = true
      },
      agregarObligacion (obligacion) {
        if (!this.newObligaciones) {
          this.newObligaciones = []
        }
        if (this.newObligaciones[this.obligacionEditIndex] !== undefined) {
          this.newObligaciones[this.obligacionEditIndex] = obligacion
        } else {
          this.newObligaciones.push(obligacion)
        }
        this.obligacionEdit = null
      },
    },
  }
</script>
